<template>
  <div class="activity">
    <h4>
      Online Activities
      <!-- <span @click="$router.push('/home/activities')">更多</span> -->
    </h4>
    <ul class="activityList">
      <li @click="$jumpWeb('https://e.cippe.com.cn/live/index_en')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/app/huodong01_en.png" alt=""/>
      </li>
      <li @click="$jumpWeb('https://oil.zhenweievents.com/')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/app/huodong02_en.png" alt=""/>
      </li>
      <li @click="$router.push('/live')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/app/huodong03_en.png" alt=""/>
      </li>
      <li @click="$jumpWeb('https://e.cippe.com.cn/live/spot_en')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/home/app/huodong04_en.png" alt=""/>
      </li>
    </ul>
    
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .activity{
    margin-bottom: 20px;
  }
  .activityList{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 15px;
    /* padding-left: 8px;
    padding-right: 8px; */
  }
  .activityList li{
    width: 49%;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 5px;
    border-radius: 5px;
  }
  
  .activityList li:focus{
    opacity: .7;
  }


  
</style>